//* Alert Component
import { AlertComponent } from './alert/alert.component';

//* Header Component
import { HeaderComponent } from './header/header.component';
import { LogoComponent } from './logo/logo.component';
import { NavDropdownComponent } from './header/top-nav/dropdown/dropdown.component';
import { NavComponent } from './header/top-nav/top-nav.component';

//* SideNav Component
import { SideNavComponent } from './side-nav/side-nav.component';

export const components = [
  AlertComponent,
  HeaderComponent,
  LogoComponent,
  NavDropdownComponent,
  SideNavComponent,
  NavComponent,
];

//* Export Components
export * from './alert/alert.component';
export * from './side-nav/side-nav.component';
export * from './header/header.component';
export * from './header/top-nav/dropdown/dropdown.component';
export * from './logo/logo.component';
export * from './header/top-nav/top-nav.component';
